import { Component, EventEmitter, Injectable, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from "@angular/material/snack-bar";
import { template_manager } from '../assets/conf_urls.json';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { UserData } from './userdata.model';

@Component({
  selector: 'app-sql-data-table',
  templateUrl: './sql-data-table.component.html',

  styleUrls: ['./sql-data-table.component.css']
})
export class SqlDataTableComponent implements OnInit {
  show_progressbar = false
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<UserData>;
  sqlRows: any;
  @Input() icon: string;
  @Input() table_name: string;
  @Input() condition: string;
  @Input() condition_key: string;
  @Input() condition_value: string;
  @Input() condition_value_type: string;
  @Input() hidden_cols: string;
  @Input() cols: string;
  @Input() query: string;
  @Input() ischeckbox: boolean;
  @Input() action_button_title: string;
  @Input() show_action_button: string;
  @Input() url: string;
  @Input() table: string;
  @Input() dropdownSources: any[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Output() formDataMessageEvent = new EventEmitter<{}>();
  @Output() messageEvent = new EventEmitter<[]>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  myFormGroup: FormGroup;
  formTemplate: any = [];
  isLinear = false;
  firstFormGroup: FormGroup;
  list_selected_items: any = [];
  list_hidden_cols: any = [];

  constructor(private _snackBar: MatSnackBar,
    private http: HttpClient,
    private _formBuilder: FormBuilder,
    private loggerService: LoggerService) {
  }

  log_item(n: any, event) {
    var flag = 0;
    var clickevent = event['checked'];
    //add
    if (clickevent == true) {
      if (this.list_selected_items.length > 0) {
        this.list_selected_items.forEach(item => {
          if (item['id'] !== n['id']) {
            flag = 0;
          } else {
            flag = 1;
          }
        });
        if (flag == 0) {
          this.list_selected_items.push(n);
        }
      } else {
        this.list_selected_items.push(n);
      }
    }
    //remove
    else {
      const index = this.list_selected_items.indexOf(n, 0);
      if (index > -1) {
        this.list_selected_items.splice(index, 1);
      }
    }
    this.sendMessage_selected_rows();
  }

  sendMessage_selected_rows() {

    this.messageEvent.emit(this.list_selected_items);

  }

  sendMessage_single_row(row) {
    this.messageEvent.emit(row);

  }

  ngsubmit() {
    // (formDataMessageEvent)="receiveMessage($event)"
    if (this.myFormGroup.valid) {
      this.formDataMessageEvent.emit(this.myFormGroup.value);
    }
  }

  generate_displayed_columns() {
    this.displayedColumns = [];
    if (this.sqlRows && this.sqlRows.length > 0) {
      Object.keys(this.sqlRows[0]).forEach(key => {
        this.displayedColumns.push(key);

      });
    }
  }


  get_sql_rows() {
    this.show_progressbar = true
    var q;
    var json_object;
    if (this.condition == "true" && this.condition_value != undefined) {
      if (this.condition_value_type == 'string' && this.condition_value != undefined) {

        q = this.query + " where " + this.condition_key + "='" + this.condition_value + "'"
      } else {
        q = this.query + " where " + this.condition_key + "=" + this.condition_value + ""

      }
    } else {
      q = this.query
    }
    json_object = {
      'q': q,
      'event': 'dt_query'
    }
    this.http.post(template_manager.table_dataset, json_object).subscribe(data => {
      if (data["status"] == "success") {
        this.show_progressbar = false
        this.sqlRows = data["data"];
        this.generate_displayed_columns();
        const dt = this.sqlRows;
        this.dataSource = new MatTableDataSource(dt);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        q = ""
        this.show_progressbar = false
        this.openSnackBar(data["message"], data["status"])

      } else {
        this.show_progressbar = false
        this.openSnackBar(data["message"], data["status"])

      }
    }, err => {
      this.loggerService.log("SqlDataTableComponent", err.message, Levels.error)
    });
    setTimeout(() => {
      this.list_hidden_cols.forEach(item => {
        $('#' + item + '_th').remove()
        $('#' + item + '_td').remove()
      })
    }, 1000)
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 8000,
      panelClass: ['mat-toolbar', 'mat-primary']
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  ngOnInit(): void {
    // this.init_form();
    // this.change_form();
    // this.get_sql_rows()
    if (this.hidden_cols != undefined) {
      if (this.hidden_cols.includes(',')) {

        this.list_hidden_cols = this.hidden_cols.split(',')

      } else {
        this.list_hidden_cols.push(this.hidden_cols)

      }
    }
  }
}
